/* how the Media pages show a video's length and date */

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** 247 → "4:07" */
export const clock = (seconds: number) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

/** 247 → "PT4M7S", for VideoObject */
export const isoDuration = (seconds: number) => `PT${Math.floor(seconds / 60)}M${seconds % 60}S`;

/** "2024-06-04T00:08:04-07:00" → "June 2024", read from the text so it never shifts with the time zone */
export const monthYear = (iso: string) => `${MONTHS[+iso.slice(5, 7) - 1]} ${iso.slice(0, 4)}`;

export const thumb = (id: string) => `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;

/** YouTube's 1280x720 thumbnail: unlike hqdefault (4:3 with black bars) it fills a box of any shape */
export const thumbWide = (id: string) => `https://i.ytimg.com/vi/${id}/hq720.jpg`;
